'use strict';

function socialShareIcons() {
    $('.social-share-trigger').on('click', function() {
        $(this).parent().toggleClass('animate');

        if (!Foundation.MediaQuery.atLeast('medium')) {
            $('#wrapper').toggleClass('overlay');
        }

    });

    $('.social-modal-close').on('click', function(){
        $(this).parent().removeClass('animate');
        $('#wrapper').removeClass('overlay');
    });
};

export default socialShareIcons;